export const AUTH_SET = 'AUTH_SET';
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN';
export const AUTH_CLEAR = 'AUTH_CLEAR';

